const SET_IFRAME_URL = '@dashboard/set-iframe-url';
const SET_BALANCE = '@dashboard/set-balance';
const SET_WITHDRAWAL_FEE = '@dashboard/set-withdrawal-fee'

export {SET_IFRAME_URL, SET_BALANCE, SET_WITHDRAWAL_FEE};
